var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.0625C3.87563 14.0625 0.9375 11.1244 0.9375 7.5C0.9375 3.87563 3.87563 0.9375 7.5 0.9375C11.1244 0.9375 14.0625 3.87563 14.0625 7.5C14.0625 11.1244 11.1244 14.0625 7.5 14.0625ZM7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
    fill: "#112299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7.5C3.75 7.24112 3.95987 7.03125 4.21875 7.03125H10.7812C11.0401 7.03125 11.25 7.24112 11.25 7.5C11.25 7.75888 11.0401 7.96875 10.7812 7.96875H4.21875C3.95987 7.96875 3.75 7.75888 3.75 7.5Z",
    fill: "#112299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionExpand);
export default __webpack_public_path__ + "static/media/accordionExpand.527be09418f4ad8b1812020cb72a16f8.svg";
export { ForwardRef as ReactComponent };